/**
 * A grid drawn as a LIST: one rule between rows and nothing else. The frame,
 * the column separators and the focus outlines are all lines around the same
 * handful of words, and inside a dialog they stack up with its own dividers.
 * (The separators only until the pointer is over the headers — see below.)
 *
 * Shared by every history view, so they look like one another: the version
 * history of a record ({@link HistoryDialog}), the project-wide parcel log
 * (ParcelHistoryDialog) and a person's links (UserLinksDialog).
 */
export const HISTORY_GRID_SX = {
    border: 0,
    /**
     * The separator is ALSO the handle that resizes a column, so it is only
     * made invisible, never removed: it shows while the pointer is over the
     * headers, where somebody about to drag a column edge is looking.
     */
    '& .MuiDataGrid-columnSeparator': { color: 'transparent' },
    '& .MuiDataGrid-columnHeaders:hover .MuiDataGrid-columnSeparator': {
        color: 'divider'
    },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
        outline: 'none'
    },
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
        { outline: 'none' },
    // The panel belongs to the row above it, so it is set back with a tint
    // rather than fenced off with a border of its own.
    '& .MuiDataGrid-detailPanel': {
        backgroundColor: 'action.hover',
        borderBottom: 0
    },
    '& .MuiDataGrid-row': { cursor: 'pointer' },
    // The version the change log sent us to. Tinted rather than outlined: the
    // row carries a detail panel underneath, and a box around one of the two
    // would cut them apart.
    '& .MuiDataGrid-row.history-row-asked-for': {
        backgroundColor: 'action.selected'
    }
};
